import { IApiCommitmentStatus } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentStatus'
import { IFetchCommitmentDataParameters } from 'legacy/lut/services/partner360/commitment/models/fetchCommitmentDataParameters'
import { planReview } from 'legacy/lut/services/partner360/commitment/planReview'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { ACTION_PLAN_REVIEW } from '../constants'

export interface IRequestCommitmentItemsParameters
  extends Omit<IFetchCommitmentDataParameters, 'ownerId'> {}

export const actionPlanReview = createAsyncThunk<
  IApiCommitmentStatus[],
  IRequestCommitmentItemsParameters
>(ACTION_PLAN_REVIEW, async ({ partnerId, fYear, programType }) => {
  return await planReview({
    partnerId,
    fYear,
    programType,
  })
})
